import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { AppRoutes } from "./routes";
import { dalakraftTheme } from "./theme/dalakraft";
import { useSelector } from "react-redux";
import { selectCompany } from "./store/slices/authSlice";
import enklaTheme from "./theme/enkla";

function BrandedApp() {
  const company = useSelector(selectCompany);
  const theme = company === "Dalakraft" ? dalakraftTheme : enklaTheme;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
}

export default BrandedApp;
